import {Component, OnInit} from '@angular/core';
import {ThemeService} from '../../services/theme.service';
import {ThemeModeEnum} from '../../../typings/enums/theme-mode.enum';

@Component({
  standalone: true,
  selector: 'app-theme-toggle',
  imports: [],
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss'
})
export class ThemeToggleComponent implements OnInit {
  isDarkMode = false;

  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.themeService.theme$.subscribe(theme => {
      this.isDarkMode = theme === ThemeModeEnum.dark;
    });
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }
}
